import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectJackpotLifecycles, selectIsJackpotsEnabled } from '@homeplay/app';

// TODO: always returns [] now. Backend no longer links games to a specific
// jackpot (per-jackpot game selection in srp_tool was removed), so
// jackpot_lifecycles[].games always comes empty. All games available for the
// site take part in all its jackpots, controlled by game.jackpotMode.
// Jackpot counters are now rendered inside the games themselves, so the card
// badge (JackpotLabel) and frame labels (JackpotGameFrameLabels) never show.
export const useJackpotsForGame = (gameSlug) => {
  const [jackpotsForGame, setJackpotsForGame] = useState([]);
  const jackpotLifecycles = useSelector(selectJackpotLifecycles);
  const isJackpotsEnabled = useSelector(selectIsJackpotsEnabled);

  useEffect(() => {
    if (!isJackpotsEnabled) {
      setJackpotsForGame([]);
      return;
    }

    const values = Object.values(jackpotLifecycles || {});
    const filtered = values
      .filter((jp) => Array.isArray(jp?.games) && jp.games.includes(gameSlug))
      .sort((a, b) => String(a.slug).localeCompare(String(b.slug)));
    setJackpotsForGame(filtered);
  }, [jackpotLifecycles, gameSlug, isJackpotsEnabled]);

  return { jackpotsForGame };
};